module.exports = __webpack_public_path__ + "img/jy-login-bg.e77a40b3.png";